export default {
  addOns: 'Zusätze',
  all: 'Alle',
  browse: 'Stöbern',
  buyTickets: 'Tickets kaufen',
  countSelected: '{{count}} ausgewählt',
  joinWaitlist: 'Zur Warteliste hinzufügen',
  joining: 'Beitritt läuft',
  noDatesAvailable: 'Keine Termine verfügbar',
  salesEnded: 'Verkauf beendet',
  schedule: 'Zeitplan',
  seeMoreDates: 'Weitere Termine anzeigen',
  soldOut: 'Ausverkauft',
  about: 'Über',
  agenda: 'Tagesordnung',
  menu: 'Menü',
  included: 'Inbegriffen',
  viewMore: 'Mehr anzeigen',
  viewLess: 'Weniger anzeigen',
  location: 'Ort',
  time: 'Zeit',
  at: 'um',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Keine Zeiten verfügbar an diesem Datum für diese Gruppengröße',
  availableTimes: 'Verfügbare Zeiten',
  waitlist: 'Warteliste',
  continue: 'Weiter',
  tickets: 'Tickets',
  ticketsAreNoLongerAvailable: 'Tickets sind nicht mehr verfügbar.',
  checkOutOutOtherExperiences: 'Schauen Sie sich unsere anderen Erlebnisse an!',
  viewExperiences: 'Erlebnisse anzeigen',
  from: 'ab',
  cancellationPolicy: 'Stornierungsbedingungen',
  rsvp: 'RSVP',
  nights: 'Nächte',
  request: 'Anfrage',
  arrival: 'Ankunft',
  departure: 'Abfahrt',
};
